(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outil', {
                url: '/outil',
                parent: 'gestion',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Outil'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/outil/outil.html',
                        controller: 'OutilController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },

                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('outil.new', {
                parent: 'outil',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/outil/outil-dialog.html',
                        controller: 'OutilDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    name: null,
                                    code: null,
                                    description: null,
                                    monthlyPrice: null,
                                    dailyPrice: null,
                                    enabled: true,
                                    technicien: null,
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('outil', null, { reload: 'outil' });
                    }, function() {
                        $state.go('outil');
                    });
                }]
            })
            .state('outil.edit', {
                parent: 'outil',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/outil/outil-dialog.html',
                        controller: 'OutilDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Outil', function(Outil) {
                                return Outil.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('outil', null, { reload: 'outil' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('outil-detail', {
                parent: 'outil',
                url: '/outil/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    // pageTitle: 'tmgApp.groupePlanning.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/outil/outil-detail.html',
                        controller: 'OutilDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Outil', function($stateParams, Outil) {
                        return Outil.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'outil',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('outil.delete', {
                parent: 'outil',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/outil/outil-delete-dialog.html',
                        controller: 'OutilDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Outil', function(Outil) {
                                return Outil.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('outil', null, { reload: 'outil' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
